export default "public/StbHorizontalLogo.png";